module.exports = __webpack_public_path__ + "img/icon3.12cf7904.658b86cb.png";